import isURL from 'validator/lib/isURL';
// @ts-ignore
import humanparser from 'humanparser';

export const assertions = {
  email(value: any, message?: string): void {
    // prettier-ignore
    if (!String(value).match(/^([\w\.%\+\-']+)@([\w\-]+\.)+([\w]{2,})$/)) { // eslint-disable-line
      throw Error(message || 'Email invalid.');
    }
  },

  firstAndLastName(value: any, message?: string): void {
    if (!humanparser.parseName(value).lastName) {
      throw Error(message || 'Please provide first and last name.');
    }
  },

  url(value: any, message?: string): void {
    if (!isURL(value)) {
      throw Error(message || 'Invalid URL');
    }
  },

  uuid(value: any, message?: string): void {
    // this regex is from this gist: https://gist.github.com/johnelliott/cf77003f72f889abbc3f32785fa3df8d
    if (!value.match(/^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i)) {
      throw Error(message || 'Invalid UUID');
    }
  },

  zipcode(value: any, message?: string): void {
    if (!value.match(/^\d{5}(?:[-\s]\d{4})?$/)) {
      throw Error(message || 'Invalid zip code.');
    }
  },

  signedInt32(value: any, message?: string): void {
    // prettier-ignore
    if ((value | 0) !== value) { // eslint-disable-line
      throw Error(message || 'Must be between -2147483648 and 2147483647.');
    }
  },

  number(value: any, message?: string): void {
    if (isNaN(value)) {
      throw Error(message || 'Must be a number.');
    }
  },

  integer(value: any, message?: string): void {
    if (Number(value) !== parseInt(value, 10)) {
      throw Error(message || 'Must be a whole number.');
    }
  },

  completePhoneNumber(value: any, message?: string): void {
    if (!value || !value.length || value.length !== 11) {
      throw Error(message || 'Invalid phone number.');
    }
  },

  emailOrPlausibleNorthAmericanPhoneNumber(value: any, message?: string): void {
    if (
      // prettier-ignore
      !String(value).match(/^([\w\.%\+\-']+)@([\w\-]+\.)+([\w]{2,})$/) && // eslint-disable-line
      // prettier-ignore
      !String(value).match(/^\+?1?[- .]?\(?\d{3}\)?[- .]?\d{3}[- .]?\d{4}$/) // eslint-disable-line
    ) {
      throw Error(message || 'Please enter a valid phone number or email address.');
    }
  },

  numberOfWordsGreaterOrEqualTo(value: any, size: number, message?: string): void {
    const numberOfWords = value.trim().split(' ').length;
    if (numberOfWords < size) {
      throw Error(message || `Must be greater than ${size} words.`);
    }
  },

  lengthLesserThanOrEqualTo(value: any, size: number, message?: string): void {
    if (!value) {
      return;
    }

    if (String(value).length > size) {
      throw Error(message || `Must be less than ${size} characters.`);
    }
  },

  lengthGreaterThanOrEqualTo(value: any, size: number, message?: string): void {
    if (String(value).length < size) {
      throw Error(message || `Must be more than ${size} characters.`);
    }
  },

  lengthEqualTo(value: any, size: number, message?: string): void {
    if (!value) {
      return;
    }

    if (String(value).length !== size) {
      throw Error(message || `Must be ${size} characters long.`);
    }
  },

  notEmpty(value: any, message?: string): void {
    if (value && value.trim) {
      value = value.trim();
    }

    if (!value) {
      throw Error(message || 'Cannot be empty.');
    }
  },

  positiveNumber(value: any, message?: string): void {
    if (value <= 0) {
      throw Error(message || 'Must be greater than 0.');
    }
  },

  valueGreaterThan(limit: number, value: any, message?: string): void {
    if (value <= limit) {
      throw Error(message || `Must be greater than ${limit}.`);
    }
  },

  withinSixMonths(date: any, message?: string): void {
    const d = new Date();
    d.setMonth(d.getMonth() + 6);
    if (date >= d) {
      throw Error(message || 'Date must be within the next 6 months.');
    }
  },

  endsWithExactString(value: any, string: string, message?: string): void {
    const valueEndsWithString = value.endsWith(string);

    if (!valueEndsWithString) {
      throw Error(message || `Must end with ${string}`);
    }
  },

  noSpaces(value: any, message?: string): void {
    const valueHasSpace = String(value).includes(' ');

    if (valueHasSpace) {
      throw Error(message || 'Must not contain any spaces.');
    }
  },

  matchRegex(value: any, regex: RegExp, message?: string): void {
    if (!String(value).match(regex)) {
      throw Error(message || 'Must match given text pattern.');
    }
  },
};

export default assertions;
